import { render, staticRenderFns } from "./Doughnut.vue?vue&type=template&id=fbf8e720&scoped=true&"
import script from "./Doughnut.vue?vue&type=script&lang=js&"
export * from "./Doughnut.vue?vue&type=script&lang=js&"
import style0 from "./Doughnut.vue?vue&type=style&index=0&id=fbf8e720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf8e720",
  null
  
)

component.options.__file = "Doughnut.vue"
export default component.exports